import "./index.scss";
import "devextreme/dist/css/dx.light.css";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Auth from "./Authentication/auth";
import Loader from "./shade/Loaders/Loaders";
import {Provider} from "react-redux";
import {store} from "./redux/store/store";
import {languages} from "./i18n/languages";
import RequireAuth from "./components/Shared/RequireAuth/RequireAuth";
const TabsView = React.lazy(() => import("./components/Shared/Tabs/TabsView"));

const App = React.lazy(() => import("../src/shade/layouts/App"));
const Switcherapp = React.lazy(
    () => import("../src/shade/layouts/Switcherapp")
);
const Custompages = React.lazy(
    () => import("../src/shade/layouts/custompages")
);
const Dashboard = React.lazy(
    () => import("./components/Dashboard/Dashboard-1/Dashboard")
);

const SignUp = React.lazy(
    () => import("./components/Pages/Authentication/SignUp/SignUp")
);
const SignIn = React.lazy(
    () => import("./components/Pages/Authentication/SignIn/SignIn")
);
const ForgotPassword = React.lazy(
    () =>
        import("./components/Pages/Authentication/ForgotPassword/ForgotPassword")
);
const Lockscreen = React.lazy(
    () => import("./components/Pages/Authentication/Lockscreen/Lockscreen")
);
const ResetPassword = React.lazy(
    () => import("./components/Pages/Authentication/ResetPassword/ResetPassword")
);
const UnderConstruction = React.lazy(
    () =>
        import(
            "./components/Pages/Authentication/UnderConstruction/UnderConstruction"
            )
);
const Error404 = React.lazy(
    () => import("./components/Pages/Authentication/404Error/404Error")
);
const Error500 = React.lazy(
    () => import("./components/Pages/Authentication/500Error/500Error")
);
const Error501 = React.lazy(
    () => import("./components/Pages/Authentication/501Error/501Error")
);

//@ts-ignore

const EmptyPage = React.lazy(
    () => import("./components/Pages/EmptyPage/EmptyPage")
);
// const NotificationsList = React.lazy(
//   () => import("./components/Pages/Notifications-list/NotificationsList")
// );
const Settings = React.lazy(
    () => import("./components/Pages/Settings/Settings")
);
const Profile = React.lazy(() => import("./components/Pages/Profile/Profile"));

i18n.use(initReactI18next).init({
    resources: languages,
    lng: "en",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

const AuthLogin = React.lazy(() => import("./Authentication/Login"));
//Form
const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <React.Fragment>
        <BrowserRouter>
            <Provider store={store}>
                <React.Suspense fallback={<Loader/>}>
                    <Routes>
                        {/* ************************* */}

                        <Route path={`${process.env.PUBLIC_URL}/`} element={<Auth/>}>
                            <Route index element={<AuthLogin/>}/>

                            <Route
                                path={`${process.env.PUBLIC_URL}/authentication/login`}
                                element={<AuthLogin/>}
                            />
                        </Route>

                        <Route path={`${process.env.PUBLIC_URL}/`} element={<App/>}>
                            <Route
                                path={`${process.env.PUBLIC_URL}/`}
                                element={<Dashboard/>}
                            />
                            <Route>
                                <Route
                                    path={`${process.env.PUBLIC_URL}/dashboard/dashboard-1`}
                                    element={
                                        <RequireAuth>
                                            <Dashboard/>
                                        </RequireAuth>
                                    }
                                />
                            </Route>

                            <Route>
                                <Route
                                    path={`${process.env.PUBLIC_URL}/app`}
                                    element={<TabsView/>}
                                />
                            </Route>

                            <Route>
                                <Route
                                    path={`${process.env.PUBLIC_URL}/pages/profile`}
                                    element={<Profile/>}
                                />
                                {/*<Route*/}
                                {/*  path={`${process.env.PUBLIC_URL}/pages/notification-list`}*/}
                                {/*  element={<NotificationsList />}*/}
                                {/*/>*/}
                                <Route
                                    path={`${process.env.PUBLIC_URL}/pages/settings`}
                                    element={<Settings/>}
                                />
                                <Route
                                    path={`${process.env.PUBLIC_URL}/pages/emptypage`}
                                    element={<EmptyPage/>}
                                />
                            </Route>
                            <Route>
                                <Route
                                    path={`${process.env.PUBLIC_URL}/pages/Authentication/501error`}
                                    element={<Error501/>}
                                />
                            </Route>
                        </Route>
                        <Route
                            path={`${process.env.PUBLIC_URL}/`}
                            element={<Custompages/>}
                        >
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/sigin`}
                                element={<SignIn/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/sigup`}
                                element={<SignUp/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/forgotpassword`}
                                element={<ForgotPassword/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/resetpassword`}
                                element={<ResetPassword/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/lockscreen`}
                                element={<Lockscreen/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/underconstruction`}
                                element={<UnderConstruction/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/404error`}
                                element={<Error404/>}
                            />
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/Authentication/500error`}
                                element={<Error500/>}
                            />
                            <Route path="*" element={<Error404/>}/>
                        </Route>

                        <Route>
                            <Route
                                path={`${process.env.PUBLIC_URL}/pages/switcher/switcher-1`}
                                element={<Switcherapp/>}
                            />
                        </Route>
                        <Route></Route>
                    </Routes>
                </React.Suspense>
            </Provider>
        </BrowserRouter>
    </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
